export default __webpack_public_path__ + "static/media/file.9cc5ee4c.svg";